import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, forkJoin, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';
import { LoaderService } from 'src/app/core/services/loader.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CareTeamService } from 'src/app/core/services/care-team.service';
import { AccessoryService } from 'src/app/core/services/accessory.service';
import { DeviceSearchService } from 'src/app/core/services/device-search.service';
import { PatientAccessoryAssignmentService } from 'src/app/core/services/patient-accessory-assignment.service';
import { PatientDeviceAssignmentService } from 'src/app/core/services/patient-device-assignment.service';
import { DeleteDeviceAccessoryRequestService } from 'src/app/core/services/delete-device-accessory-request.service';
import { v4 as uuidv4 } from 'uuid';

export class Patient {
  public id: number;
  public name: string;
  public gender: string;
  public dob: string;
  public birthDate?: string;
  public age: string;
  public patientRef: string;
  public patientExternalId: string;
  public patnr: string;
  public email: string;
  public services: string;
  public primaryproblem: string;
  public address: string;
  public location: string;
  public setupDate: string;
  public careTeam: string;
  public serialNumber: string;
  public lastUsageDate: string;
  public usage: string;
  daysUsed: string;
  avgHoursPerDay: string;
  usagePercentage: string;
  deviceCategory: string;
  accessoriesHidden: boolean = false;
  connectivityHidden: boolean = false;
  extension?: { url: string; valueDateTime?: string }[];
  patientId?: string;
  deviceIdsOfNonAssignedDevices?: string[];

  public constructor(id?: number) {
      this.id = id;
      this.name = '';
      this.dob = '';
      this.gender = '';
      this.patientRef = '';
      this.patientExternalId = '';
      this.patnr = '';
      this.email = '';
      this.services = '';
      this.primaryproblem = '';
      this.address = ''
      this.location = ''
      this.setupDate = ''
      this.careTeam = ''
      this.serialNumber = ''
      this.lastUsageDate = ''
      this.usage = ''
      this.daysUsed = ''
      this.avgHoursPerDay = ''
      this.usagePercentage = ''
      this.deviceCategory = ''
  }
}

export interface ObservationData {
  patientId: string;
  usage?: string;
  lastUsageDate?: string;
  usagePercentage?: string;
  serialNumber?: string;
}

export interface DeviceSearchData {
  patientId: string;
  serialNumber?: string;
  deviceGroup?: string;
}

export interface CareTeamData {
  patientId: string;
  careTeam?: string;
}

export interface SearchResult {
  id: string; // Unique identifier for the item (e.g., '123', 'product-abc')
  name: string; // The name field that was searched (e.g., 'John Doe', 'Product X')
  description?: string; // Optional: A brief description of the item
  imageUrl?: string; // Optional: URL to an image associated with the item
  category?: string; // Optional: Category of the item

}


@Component({
  selector: 'app-patient-management-system',
  templateUrl: '../patient-search-shared.html',
  styleUrls: ['../patient-search-shared.scss']
})

export class PatientManagementSystemComponent {
    patientTabs = ['Identity', 'Contact information', 'Care team', 'Equipment', 'Rules and reminders'];
    // Multiple selectable search types; initial state is unselected
    patientSearchTypes: string[] = [];
    activeTab = 0;
    patientCreated = false;
    lastCreatedPatientId: string | null = null;
    identityForm: FormGroup;
    contactForm: FormGroup;
    careTeamForm: FormGroup;
    rulesForm: FormGroup;
    careTeamMembers: any[] = [{ role: '', user: '' }];
    users: any[] = [
      { id: '1', name: 'PMS User' },
      { id: '2', name: 'Pooja DME' },
      { id: '3', name: 'Pooja Sub Dme' },
      // Add more users as needed
    ];
    patients: Patient[] = [];
    patientLoading: { [id: string]: boolean } = {};
    patientIds: string[] = [];
    hover: boolean = false;
    showMoreOptions = false;
    showAddPatientModal = false;
    today = new Date().toISOString().substring(0, 10);
    dummyPatients: string[] = ["28dd7216-4c7d-488c-9de1-bd5ef8e1ae85","c02b10ff-5807-456c-b20f-b3dbc759d7bc","8add6693-207f-43bd-957a-151689bf1f23","ff642372-64fd-4417-81ea-ebe1f6f80792","31602341-33d3-42d5-b7ff-89ee98c921d8","2958b82e-2c56-4ed7-a754-f49931005196","004293ac-6337-499b-8320-ea5aad927d42","61226cc1-a184-46d9-b45a-de7abc1f0780","27915475-6ab9-4a6b-8785-59d5d1b3aa50","f4841e5c-bfa9-42e6-a97f-21501cc7faff","0634e0a5-8fb3-44fc-bc12-127aaa09793e","33a02beb-ae79-4079-939f-2fd14ee55eec","9a8cb524-2d0d-34bf-b101-e8624c23ecf0","86bee7e3-51c7-3c72-a44f-9d00da56953b","824ca647-31af-3fbb-bdee-9b91714f445d","7622b527-30f8-3e54-a2c7-b13ab6a93c64","af789460-6f07-38cd-88d2-5ee46a88e824","1d8bae4e-3b9a-3dce-a1ff-783c0d48edd8","c55186a1-f5fe-3c6c-ad91-d7a70c6050d8","24dbab12-ecd5-3ea7-a42a-8cffc8f6ec02"];
    getResponse: any = {};
    selectedStatus: 'Active' | 'Inactive' | 'All' = 'Active';
    selectedSort: string = 'setup';
    sortDirection: 'asc' | 'desc' = 'desc';
    selectedPatient: Patient | null = null;
    notification: { show: boolean; message: string; type: 'success' | 'error' } = { show: false, message: '', type: 'success' };
    ruleSets: any[] = [];
    selectedRuleSetId: string = '';
  // searchResults: any[] = [];
  // private searchTerms = new Subject<string>();
  searchTerm: string = '';
  searchResults: SearchResult[] = []; // Use the imported interface for type safety
  private searchSubject = new Subject<string>();
  isLoadings: boolean = false;
  errorMessage: string = '';
  selectedDevice = {
    device: '',
    serialNumber: '',
    assignmentDate: '',
    dataSource: '',
    id: ''
  };
  selectedConnectivity = {
    type: '',
    provider: '',
    identifier: '',
    assignmentDate: '',
    resupplyDate: ''
  };
  selectedAccessory = {
    type: '',
    model: '',
    detail: '',
    assignmentDate: '',
    resupplyDate: ''
  };

  devicesHidden: boolean = true;
  connectivityHidden: boolean = true;
  accessoriesHidden: boolean = true;
  savedDevices: any[] = [];
  savedConnectivity: any[] = [];
  savedAccessories: any[] = [];
  selectedDeviceIds: string[] = [];

  accessoryOptions: { [key: string]: { models: string[]; details: string[] } } = {
    Cushion: {
      models: ['Amara Cushion', 'Amara Gel Cushion', 'ComfortGel Cushion', 'DreamWear Cushion', 'DreamWear Full Cushion', 'DreamWear Gel Cushion'],
      details: ['Petite', 'Small', 'Medium', 'Large']
    },
    Headgear: {
      models: ['Amara Headgear', 'Amara View Headgear', 'DreamWear Frame', 'DreamWear Full Headgear', 'DreamWear Headgear'],
      details: ['Petite', 'Small', 'Medium', 'Large']
    },
    Mask: {
      models: ['Amara Silicone', 'Amara View', 'Comfort Classic', 'Comfort Full', 'Comfort Fusion'],
      details: ['Extra Small', 'Small', 'Medium', 'Large', 'Extra Large']
    },
    'Breathing Circuit': {
      models: ['Active', 'Adapter', 'Passive'],
      details: ['Adult with heated wire', 'Pediatric with heated wire', 'Peadiatric with water trap']
    }
  };

  get accessoryTypes(): string[] {
    return Object.keys(this.accessoryOptions);
  }


  get models(): string[] {
    return this.selectedAccessory.type ? this.accessoryOptions[this.selectedAccessory.type]?.models || [] : [];
  }

  get details(): string[] {
    return this.selectedAccessory.type ? this.accessoryOptions[this.selectedAccessory.type]?.details || [] : [];
  }

    constructor(
      private http: HttpClient,
      private appProfile: AppProfile,
      private authService: AuthService,
      public loaderService: LoaderService,
      private fb: FormBuilder,
      private careTeamService: CareTeamService,
      private accessoryService: AccessoryService,
      private deviceSearchService: DeviceSearchService,
      private accessoryRequestService: PatientAccessoryAssignmentService,
      private deviceRequestService: PatientDeviceAssignmentService,
      private deviceDeleteRequestService: DeleteDeviceAccessoryRequestService
  ) {
      this.identityForm = this.fb.group({
        location: ['', Validators.required],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        dob: ['', Validators.required],
        gender: ['', Validators.required],
        setupDate: ['', Validators.required],
        patientExternalId: [''],
        patientReference: [''],
        payer: [''],
        secondaryPayer: [''],
        payerMemberId: [''],
        secondaryPayerMemberId: ['']
    });
    this.searchSubject.pipe(
      debounceTime(300), // Wait for 300ms after the last keystroke
      distinctUntilChanged(), // Only emit if the value has changed
      switchMap((term: string) => {
        this.isLoadings = true; // Set loading state
        this.errorMessage = ''; // Clear previous errors
        return this.careTeamService.searchByName(term).pipe(
          catchError(error => {
            console.error('Search API error:', error);
            this.errorMessage = 'Failed to fetch search results. Please try again.';
            this.isLoadings = false;
            return of([]); // Return an empty array on error to prevent breaking the stream
          })
        );
      })
    ).subscribe(results => {
      this.searchResults = results;
      this.isLoadings = false; // Clear loading state
    });
  }

  saveDevice() {
    const { device, serialNumber, assignmentDate, dataSource } = this.selectedDevice;

    this.deviceSearchService.searchDevices(serialNumber).subscribe({
      next: (response: any) => {
        const entries = response?.entry || [];

        if (entries.length > 0) {
          const deviceIdsOfNonAssignedDevices = entries
            .map((entry: any) => entry?.resource?.id)
            .filter((id: string) => !!id);

          // Store for later use in sendRequest()
          this.selectedDeviceIds = deviceIdsOfNonAssignedDevices;

          const savedDevice = {
            device: '',
            serialNumber,
            assignmentDate,
            dataSource,
            id: '',
            deviceIdsOfNonAssignedDevices
          };

          // Push it to the savedDevices array
          this.savedDevices.push(savedDevice);

          // Now reset selectedDevice
          this.selectedDevice = {
            device: '',
            serialNumber: '',
            assignmentDate: '',
            dataSource: '',
            id: ''
          };

          this.devicesHidden = true;
          this.sendRequest(); // Call sendRequest after saving the device
        }

        else {
          this.savedDevices.pop();
          alert('Invalid serial number. No matching device found.');
        }
      },
      error: err => {
        this.savedDevices.pop();
        alert('An error occurred while verifying the serial number.');
      }
    });

    this.devicesHidden = true;

  }


  sendRequest() {
    if (!this.selectedDeviceIds || this.selectedDeviceIds.length === 0) {
      alert('No device selected. Please save a device first.');
      return;
    }

    const payload = {
      resourceType: "DeviceRequest",
      meta: {
        profile: ["https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmDeviceRequest"]
      },
      identifier: [{
        system: "http://www.happysight.com/prescription",
        value: "15013L"
      }],
      status: "completed",
      intent: "original-order",
      codeReference: {
        identifier: {
          system: "http://www.philips.com/ampm",
          value: this.selectedDeviceIds[0] // Use first matched device ID
        }
      },
      subject: {
        reference: "Patient/example",
        identifier: {
          system: "http://www.philips.com/ampm",
          value: this.lastCreatedPatientId
        }
      },
      occurrenceDateTime: this.savedDevices[0].assignmentDate,
      authoredOn: this.savedDevices[0].assignmentDate,
      extension: [{
        url: "https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmPrimaryDeviceExtension",
        valueBoolean: true
      }]
    };

    this.deviceRequestService.createDeviceRequest(payload).subscribe({
      next: (response) => {
        this.savedDevices[this.savedDevices.length - 1].id = response['id'];
        console.log('Device request sent successfully:', response);
      },
      error: (error) => {
        this.savedDevices.pop();
        console.error('Failed to send device request:', error);
        alert('Failed to send device request. Please try again.');
      }
    });
  }

  editDevice(index: number) {
    const deviceToEdit = this.savedDevices[index];
    this.selectedDevice = { ...deviceToEdit };
    this.savedDevices.splice(index, 1);
    this.devicesHidden = false;
  }


  deleteDevice(index: number, deviceId: string): void {
    const deviceToDelete = this.savedDevices[index];
    console.log(deviceToDelete + "," + deviceId);
    this.deviceDeleteRequestService
      .deleteDeviceRequest(this.deviceDeleteRequestService.getTenantId(), this.authService.accessToken, deviceId)
      .subscribe({
        next: () => {
          // Remove from local list only after successful deletion
          this.savedDevices.splice(index, 1);
          console.log('DeviceRequest deleted successfully');
        },
        error: (err) => {
          console.error('Error deleting DeviceRequest:', err);
          alert('Failed to delete device. Please try again.');
        }
      });
   }

  saveAccessory() {
    const serialNumber = uuidv4(); // Generate UUID

    // Copy accessory data and assign UUID
    const accessoryCopy: any = {
      ...this.selectedAccessory,
      serialNumber: serialNumber
    };

    this.savedAccessories.push(accessoryCopy); // Add to list

    // Reset form
    this.selectedAccessory = {
      type: '',
      model: '',
      detail: '',
      assignmentDate: '',
      resupplyDate: ''
    };

    // Build payload and send to service
    this.accessoryRequestService.saveAccessory(accessoryCopy, serialNumber, this.lastCreatedPatientId).subscribe(
      (response) => {
        accessoryCopy.id = response?.id;
      },
      (error) => {
        this.savedAccessories.pop();
        alert('An error occurred while saving accessory.');
      }
    );



    this.accessoriesHidden = true;
  }

  editAccessory(index: number) {
    const accessoryToEdit = this.savedAccessories[index];
    this.selectedAccessory = { ...accessoryToEdit };
    this.savedAccessories.splice(index, 1);
    this.accessoriesHidden = false;
  }

  deleteAccessory(index: number): void {
    console.log("Delete accessory at index:", index);
    const accessoryToDelete = this.savedAccessories[index];

    if (!accessoryToDelete?.id) {
      console.warn('No ID found for accessory, cannot delete.');
      return;
    }

    this.deviceDeleteRequestService
      .deleteDeviceRequest(this.deviceDeleteRequestService.getTenantId(), this.authService.accessToken, accessoryToDelete.id)
      .subscribe({
        next: () => {
          // Remove from local list only after successful deletion
          this.savedAccessories.splice(index, 1);
          console.log('Accessory deleted successfully');
        },
        error: (err) => {
          console.error('Failed to delete accessory:', err);
        }
      });
  }

    ngOnInit() {
      this.fetchPatients();
      this.contactForm = this.fb.group({
        phoneNumber: [''],
        preferredNumber: [false],
        email: [''],
        preferredContactMethod: [''],
        streetAddress: [''],
        postalCode: [''],
        city: [''],
        state: [''],
        country: ['India'],
        timeZone: ['', Validators.required],
        startTime: ['12:00']
      });
      this.careTeamForm = this.fb.group({
        role0: ['clinician'],
        user0: ['1']
      });
      this.rulesForm = this.fb.group({
        complianceRule: ['rule1'],
        ruleSet: ['company'],
        reminderSet: [['company']]
      });
      this.fetchRuleSets();
    }

  onSearchChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchTerm = inputElement.value;
    this.searchSubject.next(this.searchTerm);
  }

  addCareTeamMember() {
    const idx = this.careTeamMembers.length;
    this.careTeamMembers.push({ role: '', user: '' });
    this.careTeamForm.addControl('role' + idx, this.fb.control('clinician'));
    this.careTeamForm.addControl('user' + idx, this.fb.control('1'));
  }

    removeCareTeamMember(i: number) {
      this.careTeamMembers.splice(i, 1);
      this.careTeamForm.removeControl('role' + i);
      this.careTeamForm.removeControl('user' + i);
    }

  get isLoading() {
    return this.loaderService.loading$;
  }

  filterStatus(status: 'Active' | 'Inactive' | 'All') {
      this.selectedStatus = status;
      // Add filtering logic here
  }

  toggleSortDirection() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    // Add sorting logic here
  }

    private getCommonHeaders(): HttpHeaders {
    const accessToken = this.authService.accessToken;
    if (!accessToken) {
      console.error('Access token is missing. Please ensure you are logged in.');
      return;
    }
    return new HttpHeaders({
      'X-tenant-Id': '2faca8f1-c381-4122-a634-471e1075dd8d',
      'Content-Type': 'application/json',
      'org': '2faca8f1-c381-4122-a634-471e1075dd8d',
      'Authorization': `Bearer ${accessToken}`,
      'api-version': '1.0.0'
    });
  }

  /**
   * Shared patient search logic for both fetchPatients (default) and searchPatients (with params)
   */
  private getOrderedPatientSearchTypes(types: string[] = []): string[] {
    const order = ['exact', 'partial', 'fuzzy'];
    return order.filter(t => types.includes(t));
  }

  private async doPatientSearch(searchBody: any, isSearchAll: boolean = true, searchTypes?: string[]) {
    let headers = this.getCommonHeaders().set('api-version', isSearchAll ? '1.0.0' : '1.0.0');
    // Only set the patient-search-type header when explicitly provided by user search
    const ordered = this.getOrderedPatientSearchTypes(searchTypes || []);
    if (ordered.length > 0) {
      headers = headers.set('patient-search-type', ordered.join(','));
    }
    const orgId = this.getCommonHeaders().get('org');
    this.patients = [];
    this.patientLoading = {};
    try {
      const endpoint = isSearchAll ? '_searchAll' : '_search';
      const response: any = await this.http.post(`${this.appProfile.ampmUs}/pms/fhir/${orgId}/Patient/${endpoint}`,
        searchBody, { headers }).toPromise();
      if (response && response.entry) {
        this.patients = response.entry.map((entry: any) => {
          this.patientIds.push(entry.resource.id.toString());
          const patient = Object.assign(new Patient(entry.resource.id), entry.resource);
          patient.name = Array.isArray(entry.resource.name) && entry.resource.name.length > 0
            ? `${entry.resource.name[0].given?.join(' ') || ''} ${entry.resource.name[0].family || ''}`.trim()
            : 'Unknown';
          patient.dob = entry.resource.birthDate;
          patient.gender = entry.resource.gender;
          patient.address = Array.isArray(entry.resource.address) && entry.resource.address.length > 0
            ? entry.resource.address.map((addr: any) => addr.country || addr.text || 'N/A').join(', ')
            : 'N/A';
          const setupDateExtension = entry.resource.extension?.find((ext: any) =>
            ext.url === "https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmSetupDateExtension"
          );
          if (setupDateExtension && setupDateExtension.valueDateTime) {
            patient.setupDate = setupDateExtension.valueDateTime;
          }
          this.patientLoading[patient.id] = true;
          return patient;
        });
          this.fetchPatientsAndData();
        // Clear any error notification on success
        this.notification.show = false;
      } else {
        this.patients = [];
        // Show warning message for empty results
        this.notification = {
          show: true,
          message: 'No patients found matching your criteria.',
          type: 'error'
        };
        setTimeout(() => { this.notification.show = false; }, 5000);
      }
    } catch (error: any) {
      this.patients = []; // Clear patient list on error
      console.error('Error searching patients:', error);
      this.loaderService.hide();

      // Extract and display error message
      let errorMsg = 'Failed to search patients. Please try again.';
      if (error?.status === 400) {
        // Try to extract validation error message
        if (error?.error?.validationErrors && Array.isArray(error.error.validationErrors) && error.error.validationErrors.length > 0) {
          const validationError = error.error.validationErrors[0];
          if (validationError?.errorMessage) {
            // Extract the actual error message from nested string
            const match = validationError.errorMessage.match(/errorMessage=(.+?)\)/);
            errorMsg = match ? match[1] : validationError.errorMessage;
          }
        } else {
          errorMsg = error?.error?.message || 'Bad Request. Please check your search criteria.';
        }
      } else if (error?.status === 401) {
        errorMsg = 'Unauthorized. Please log in again.';
      } else if (error?.status === 403) {
        errorMsg = 'Access Denied. You do not have permission to search patients.';
      } else if (error?.status === 404) {
        errorMsg = 'No patients found matching your criteria.';
      } else if (error?.status === 500) {
        errorMsg = error?.error?.message || 'Server Error. Please contact support.';
      } else if (error?.message) {
        errorMsg = error.message;
      }

      this.notification = {
        show: true,
        message: errorMsg,
        type: 'error'
      };
      // Auto-hide notification after 5 seconds
      setTimeout(() => { this.notification.show = false; }, 5000);
    } finally {
      this.loaderService.hide();
    }
  }

  fetchPatients(): void {
    const body = {
      active: true,
      pagination: { page: 1, _count: 20 },
      sorting: { sortField: 'setupDate', sortDirection: 'DESC' }
    };
    // Do not send patient-search-type on initial load
    this.doPatientSearch(body, true);
  }

  async searchPatients(name: string, dob: string, postal: string, phone: string, searchTypes?: string[]) {
    const body: any = {
      active: true,
      pagination: { _count: 100, page: 1 },
      sorting: { sortDirection: 'DESC', sortField: 'setupDate' }
    };
    if (name) {
      const [given, ...familyArr] = name.split(' ');
      body.given = given;
      if (familyArr.length) body.family = familyArr.join(' ');
    }
    if (dob) body.birthDate = dob;
    if (postal) body.postalCode = postal;
    if (phone) body.phone = phone;
    await this.doPatientSearch(body, false, searchTypes);
  }

  sortPatients(criteria: string): void {
    if (criteria === 'name') {
      this.patients.sort((a, b) => a.name.localeCompare(b.name));
    } else if (criteria === 'dob') {
      this.patients.sort((a, b) => new Date(a.dob).getTime() - new Date(b.dob).getTime());
    } else if (criteria === 'setupDate') {
      this.patients.sort((a, b) => new Date(a.setupDate).getTime() - new Date(b.setupDate).getTime());
    }
  }

  toggleOptions(event: Event) {
    event.preventDefault();
    this.showMoreOptions = !this.showMoreOptions;
  }

  togglePatientSearchType(type: string, checked: boolean) {
    if (checked) {
      if (!this.patientSearchTypes.includes(type)) this.patientSearchTypes.push(type);
    } else {
      this.patientSearchTypes = this.patientSearchTypes.filter(t => t !== type);
    }
  }

  fetchPatientsAndData(): void {
    const headers = this.getCommonHeaders().set('api-version', '1.0.0');
    const patientIdBody = { id: this.patientIds };

    // Set all patient loading to true before API call
    this.patients.forEach(p => this.patientLoading[p.id] = true);

    const observationApi = this.http
      .post<{ observationData: ObservationData[] }>(
        `${this.appProfile.ampmUs}/pms/observation`,
        patientIdBody,
        { headers }
      );

    const deviceSearchApi = this.http
      .post<{ deviceDetailsList: DeviceSearchData[] }>(
        `${this.appProfile.ampmUs}/ems/bulk-patient-device-search`,
        patientIdBody,
        { headers }
      );

    const careTeamApi = this.http
    .post<{ patientCareTeamList: CareTeamData[] }>(
      `${this.appProfile.ampmUs}/ctm/PatientCareTeam`,
      patientIdBody,
      { headers }
    );

    forkJoin({
      observation: observationApi,
      deviceSearch: deviceSearchApi,
      careTeam: careTeamApi,
      }).subscribe({
      next: ({ observation, deviceSearch, careTeam }) => {
        this.updatePatientsFromObservation(observation.observationData);
        this.updatePatientsFromDeviceSearch(deviceSearch.deviceDetailsList);
        this.updatePatientsFromCareTeam(careTeam.patientCareTeamList);
        // Set all patient loading to false
        this.patients.forEach(p => this.patientLoading[p.id] = false);
        console.log('All data fetched and processed successfully.');
      },
      error: (error) => {
        // Set all patient loading to false on error
        this.patients.forEach(p => this.patientLoading[p.id] = false);
        // Always force loader to stop on error
        while (this.loaderService['requestCount'] > 0) {
          this.loaderService.hide();
        }
        console.error('Error in one of the API calls:', error.message ?? error);
      },
      });
  }

  private updatePatientsFromObservation(data: ObservationData[] = []): void {
    data.forEach(({ patientId, lastUsageDate, usagePercentage, usage }) => {
      const patient = this.patients.find(p => p.id.toString() === patientId);
      if (patient) {
        patient.lastUsageDate = lastUsageDate ?? patient.lastUsageDate;
        patient.usagePercentage = usagePercentage ?? patient.usagePercentage;
        patient.usage = usage ?? patient.usage;
      }
    });
  }

  private updatePatientsFromDeviceSearch(data: DeviceSearchData[] = []): void {
    data.forEach(({ patientId, serialNumber, deviceGroup }) => {
      const patient = this.patients.find(p => p.id.toString() === patientId);
      if (patient) {
        patient.serialNumber = serialNumber ?? patient.serialNumber;
        patient.deviceCategory = deviceGroup ?? patient.deviceCategory;
      }
    });
  }

  private fetchUserAndOrgDetails(clinicianIds: string[], locationIds: string[]): Observable<any[]> {
    const calls = [];
    if (clinicianIds.length > 0) {
      calls.push(this.fetchDetails(clinicianIds, 'user'));
    }
    if (locationIds.length > 0) {
      calls.push(this.fetchDetails(locationIds, 'org'));
    }
    return forkJoin(calls);
  }

  private updatePatientsFromCareTeam(data: CareTeamData[] = []): void {
    // Map patientId to patient.id for later mapping
    const patientIdToPatientId: { [key: string]: string } = {};
    this.patients.forEach(p => {
      patientIdToPatientId[p.id.toString()] = p.id.toString();
    });

    // Build maps for clinician and location ids per patient
    const allClinicianIds: string[] = [];
    const allLocationIds: string[] = [];
    const patientClinicianMap: { [patientId: string]: string[] } = {};
    const patientLocationMap: { [patientId: string]: string[] } = {};
    data.forEach(({ patientId, careTeam }) => {
      const patient = this.patients.find(p => p.id.toString() === patientId);
      if (patient && Array.isArray(careTeam) && careTeam.length > 0) {
        const clinicianIds = careTeam.filter(ct => ct.type === 'clinician').map(ct => ct.id);
        const locationIds = careTeam.filter(ct => ct.type === 'location').map(ct => ct.id);
        if (clinicianIds.length > 0) {
          allClinicianIds.push(...clinicianIds);
          patientClinicianMap[patientId] = clinicianIds;
        }
        if (locationIds.length > 0) {
          allLocationIds.push(...locationIds);
          patientLocationMap[patientId] = locationIds;
        }
      }
    });
    const uniqueClinicianIds = Array.from(new Set(allClinicianIds));
    const uniqueLocationIds = Array.from(new Set(allLocationIds));
    if (uniqueClinicianIds.length > 0 || uniqueLocationIds.length > 0) {
      this.fetchUserAndOrgDetails(uniqueClinicianIds, uniqueLocationIds).subscribe({
        next: (results) => {
          let userResult, orgResult;
          if (uniqueClinicianIds.length > 0 && uniqueLocationIds.length > 0) {
            userResult = results[0];
            orgResult = results[1];
          } else if (uniqueClinicianIds.length > 0) {
            userResult = results[0];
          } else if (uniqueLocationIds.length > 0) {
            orgResult = results[0];
          }
          // Map user/org results back to patients using patientId
          if (userResult || userResult.orgUserDatalist) {
            userResult.orgUserDatalist.forEach((user: any) => {
              Object.keys(patientClinicianMap).forEach(pid => {
                if (patientClinicianMap[pid].includes(user.id)) {
                  const patient = this.patients.find(p => p.id.toString() === pid);
                  if (patient) {
                    patient.careTeam = user.name || user.id;
                  }
                }
              });
            });
          }
          // Bind patient.location from orgResult
          if (orgResult && orgResult.entry) {
            orgResult.entry.forEach((org: any) => {
              Object.keys(patientLocationMap).forEach(pid => {
                if (patientLocationMap[pid].includes(org.id)) {
                  const patient = this.patients.find(p => p.id.toString() === pid);
                  if (patient) {
                    patient.location = org.name || org.id;
                  }
                }
              });
            });
          }
        },
        error: (err) => {
          console.error('Error fetching user/org details:', err);
        }
      });
    }
  }

  /**
   * Fetch details from the PMS user or org API.
   * @param ids Array of user or org IDs.
   * @param type 'user' or 'org'
   */
  fetchDetails(ids: string[], type: 'user' | 'org'): Observable<any> {
    const headers = this.getCommonHeaders().set('api-version','1.0.0');
    const body = { id: ids };
    const endpoint = type === 'user' ? 'user' : 'org';
    return this.http.post<any>(`${this.appProfile.ampmUs}/pms/${endpoint}`, body, { headers });
  }

  openPatientCarePlan(patient: Patient) {
    this.selectedPatient = patient;
  }

    async createPatient() {
    if (this.identityForm.valid) {
      const token = this.authService.token;
      if (!token) {
        console.error('Access token is missing. Please ensure you are logged in.');
        return;
      }
      const headers = this.getCommonHeaders().set('auth-token', token);
      const form = this.identityForm.value;
      const body = {
        organization: { orgId: '3bade2c0-6bb3-471a-940a-5c7e59b1ce90' },
        firstName: form.firstName,
        lastName: form.lastName,
        setupDate: form.setupDate,
        gender: form.gender,
        patientExternalId: form.patientExternalId || '',
        patientReference: form.patientReference || '',
        externalIntegrators: ["Billing"],
        careTeamMembers: [
          { id: "f59ea11a-2692-45af-937b-0a6773e29aa9", system: "http://www.philips.com" }
        ],
        dateOfBirth: form.dob,
        timezone: "America/New_York",
        countryCode: "US",
        payers: [
          { payerId: "6952f126-13d2-47da-ae86-09e74260b55d", isPrimary: true, subscriberId: "2aee032c-06d0-4028-b0c5-a46a4a5338e3" },
          { payerId: "b701a460-d7ea-4767-9b61-6a10a19cdda7", isPrimary: false, subscriberId: "8aabd6ca-3215-440f-b979-403dd33afeca" }
        ],
        contactPoints: [
          { preferred: true, system: "phone", use: "home", value: "(+91)9674084922" }
        ]
      };
      try {
        const response: any = await this.http.post(`${this.appProfile.epUs}/pws/Patient`, body, { headers, observe: 'response' }).toPromise();
        if (response && response.status === 201) {
          this.patientCreated = true;
          // Save the last created patient id if available in response body
          this.lastCreatedPatientId = (response.body as any)?.patientId ?? null;
          this.notification = { show: true, message: 'Patient Created Successfully', type: 'success' };
          setTimeout(() => { this.notification.show = false; }, 3000);
          this.activeTab = 1; // Move to next tab
        } else {
          this.notification = { show: true, message: 'Failed to Create Patient', type: 'error' };
          setTimeout(() => { this.notification.show = false; }, 3000);
        }
      } catch (error) {
        this.notification = { show: true, message: 'Failed to Create Patient', type: 'error' };
        setTimeout(() => { this.notification.show = false; }, 3000);
      } finally {
        this.loaderService.hide();
      }
    } else {
      this.identityForm.markAllAsTouched();
    }
  }

  goToPreviousTab() {
    if (this.activeTab > 0) this.activeTab--;
  }

  skipCurrentTab() {
    if (this.activeTab < 4) this.activeTab++;
  }

  skipAllTabs() {
    this.activeTab = 4;
  }

  isCurrentFormValid(): boolean {
    switch (this.activeTab) {
      case 0: return this.identityForm.valid;
      case 1: return this.contactForm.valid;
      case 2: return this.careTeamForm.valid;
      case 3: return true; // Add validation if needed
      case 4: return true; // Add validation if needed
      default: return true;
    }
  }

  saveCurrentTab() {
    switch (this.activeTab) {
      case 0:
        this.createPatient();
        break;
      case 1:
        // Save contact info logic here
        this.skipCurrentTab();
        break;
      case 2:
        // Save care team logic here
        this.skipCurrentTab();
        break;
      case 3:
        // Save equipment logic here
        this.skipCurrentTab();
        break;
      case 4:
        // Save rules/reminders logic here
        this.callRuleAssignmentAPI();
        this.showAddPatientModal = false;
        break;
      default:
        break;
    }
  }

  fetchRuleSets() {
    const headers = this.getCommonHeaders().set('api-version', '2.0.0');
    const orgId = this.getCommonHeaders().get('org');
    this.http.get<any>(`${this.appProfile.ampmUs}/pes/fhir/${orgId}/RuleSet`, { headers }).subscribe(res => {
      if (res && res.entry) {
        this.ruleSets = res.entry.map((e: any) => ({
          id: e.resource.id,
          title: e.resource.title || e.resource.name || 'Untitled',
          status: e.resource.status,
          rules: ''
        }));
        if (this.ruleSets.length > 0) {
          this.selectedRuleSetId = this.ruleSets[0].id;
        }
      }
    });
  }

  callRuleAssignmentAPI() {
    // Find the selected RuleSet object
    const selectedRuleSet = this.ruleSets.find(rs => rs.id === this.selectedRuleSetId);
    // if (!selectedRuleSet || !this.selectedPatient) {
    //   this.notification = { show: true, message: 'Please select a RuleSet and Patient', type: 'error' };
    //   setTimeout(() => { this.notification.show = false; }, 3000);
    //   return;
    // }
    const planDefinitionUrl = selectedRuleSet.fullUrl || `http://hl7.org/fhir/PlanDefinition/${selectedRuleSet.id}`;
    // Use selectedPatient if available, otherwise fallback to last created patient id
    let patientId: any = this.selectedPatient?.id;
    if (!patientId && this.patientCreated && this.notification.type === 'success') {
      // Try to get patient id from last createPatient response if available
      patientId = this.lastCreatedPatientId ? this.lastCreatedPatientId : undefined;
    }
    if (!patientId) {
      this.notification = { show: true, message: 'Patient ID not found. Please create/select a patient.', type: 'error' };
      setTimeout(() => { this.notification.show = false; }, 3000);
      return;
    }
    const body = {
      resourceType: 'CarePlan',
      instantiatesCanonical: [planDefinitionUrl],
      status: 'active',
      intent: 'plan',
      subject: {
        identifier: {
          value: patientId,
          system: 'http://philips.com/ampm'
        },
        type: 'Patient'
      }
    };
    const headers = this.authService.getCommonHeaders('2.0.0').set('accept', 'application/json');
    const orgId = this.getCommonHeaders().get('org');
    this.http.post(`${this.appProfile.ampmUs}/pes/fhir/${orgId}/CarePlan`, body, { headers, observe: 'response' })
      .subscribe({
        next: (response: any) => {
          if (response.status === 201) {
            this.notification = { show: true, message: 'RuleSet Assigned to the Patient', type: 'success' };
            setTimeout(() => { this.notification.show = false; }, 3000);
          } else {
            this.notification = { show: true, message: 'Failed to assign RuleSet', type: 'error' };
            setTimeout(() => { this.notification.show = false; }, 3000);
          }
        },
        error: (err) => {
          this.notification = { show: true, message: 'Failed to assign RuleSet', type: 'error' };
          setTimeout(() => { this.notification.show = false; }, 3000);
        }
      });
  }

}
